(ns common.feedback-reasons
  (:require [common.util :as cu]))

(defonce options [{:key   :feedback.reason/report-bug
                   :label "Report a bug"}
                  {:key   :feedback.reason/suggestion
                   :label "Leave us a suggestion"}
                  {:key   :feedback.reason/compliment
                   :label "Leave us a compliment"}
                  {:key   :feedback.reason/other
                   :label "Something else"}])

(def get-key (partial cu/get-key options))

(def get-label (partial cu/get-label options))
